<!--页头-->
<template>
  <div style="background-color:white;">
    <!--顶部的图片-->
    <div class="content-top" style="height: 130px;100%;margin:0 auto;background-color:white;border-bottom:8px solid #0064e8;">
      <div v-if="this.$store.state.Token" class="helloUse">
        <span>您好！</span>
        <span class="helloUsename" @click="ifOutload">{{yourName}}</span>
      </div>
      <div style="position:relative; height: 130px;width:1150px;margin:0 auto;">
         <div v-if="!this.$store.state.Token" style="position:absolute;right:0;z-index:100;height:100px;width:500px;">
        <router-link to="/onload" class="routerBtn">
          <button class="onloadBtn btn">登录</button>
        </router-link>
        <router-link to="/apply" class="routerBtn1">
          <button class="applyBtn btn">会员注册</button>
        </router-link>
      </div>
        <img src="../../assets/img/headerBgNew.png" style="height: 117px;width:454px;">
      </div>
      <!--现有的图暂时用本地的-->
      <!--<img :src="this.topImg"/>-->
      <!--原有的背景图是调用接口的-->
    </div>
    <div class="content-nav">
      <nav class="nav-body" role="navigation">
        <ul class="nav-ul nav nav-pills" style="flex-wrap: nowrap;justify-content: center;">
          <li v-if="titles[0] !== undefined">
            <router-link style="color: #000000" :style="ifblueho" href="#" to="/" >{{titles[0].title}}</router-link>
          </li>
          <li v-if="titles[1] !== undefined">
            <router-link style="color: #000000"  :style="ifbluein" href="#" to="/introduce">{{titles[1].title}}</router-link>
          </li>
          <li v-if="titles[2] !== undefined">
            <router-link style="color: #000000"  :style="ifbluene" href="#" to="/news">{{titles[2].title}}</router-link>
          </li>
          <li v-if="titles[3] !== undefined">
            <router-link style="color: #000000"  :style="ifbluech" href="#" to="/character">{{titles[3].title}}</router-link>
          </li>
          <li v-if="titles[4] !== undefined">
            <router-link style="color: #000000"  :style="ifbluepa" href="#" to="/paper">{{titles[4].title}}</router-link>
          </li>
          <li v-if="titles[5] !== undefined">
            <router-link style="color: #000000"  :style="ifblueno" href="#" to="/notice">{{titles[5].title}}</router-link>
          </li>
          <li v-if="titles[6] !== undefined">
            <router-link style="color: #000000"  :style="ifblueme" href="#" to="/member">{{titles[6].title}}</router-link>
          </li>
          <li v-if="titles[7] !== undefined">
            <router-link style="color: #000000"  :style="ifbluese" href="#" to="/service">{{titles[7].title}}</router-link>
          </li>
          <li v-if="titles[8] !== undefined">
            <router-link style="color: #000000"  :style="ifbluejo" href="#" to="/join">{{titles[8].title}}</router-link>
          </li>
          <router-view></router-view>
        </ul>
      </nav>
    </div>
  </div>
</template>

<script>
import HttpServer from '@/utils' // 接口请求
export default {
  props: ['ifblueho', 'ifbluein', 'ifbluene', 'ifbluech', 'ifbluepa', 'ifblueno', 'ifblueme', 'ifbluese', 'ifbluejo'],
  data () {
    return {
      // 顶部主背景图
      topImg: '',
      // 导航栏数据
      titles: [],
      // 用户名
      yourName: ''
    }
  },
  methods: {
    // 退出登录
    ifOutload: function () {
      this.$confirm('是否退出登录继续?', '退出', {
        confirmButtonText: '退出',
        cancelButtonText: '取消',
        type: 'info'
      }).then(() => {
        // 清空token中的数据
        this.$store.commit('add', {'token': '', 'nickname': '', 'group': ''})
        // 清空localStorage中的数据
        localStorage.setItem('userName', null)
        localStorage.setItem('userToken', '')
        localStorage.setItem('userGroup', '')
        // 跳转到登录界面
        this.$router.push('/onload')
        this.$message({
          type: 'success',
          message: '您已退出!'
        })
      }).catch(() => {
      })
    }
  },
  mounted () {
    // *** local -> token ***后面要有个接口验证token
    // 如果local的token不为空
    if (localStorage.getItem('userToken') !== null) {
      // 把token和user和group传给vuex
      this.$store.commit('add', {'token': localStorage.getItem('userToken'), 'nickName': localStorage.getItem('userName'), 'group': localStorage.getItem('userGroup')})
      // 为本组件的name传值
      this.yourName = localStorage.getItem('userName')
    }

    // 调用导航栏接口
    HttpServer.get('http://ysw.861718.com/gdics.php/index/nav').then(res => {
      this.titles = res
    })

    // 调用顶部背景图
    HttpServer.get('http://ysw.861718.com/gdics.php/index/top').then(res => {
      this.topImg = res
    })
  }
}
</script>

<style>
  .routerBtn{
    position: absolute;
    right: 120px;
    top:40%;
  }
  .routerBtn1{
    position: absolute;
    right:15px;
    top:40%;
  }
  .applyBtn{
    width:80px;
    height: 25px;
    border-radius: 50px !important;
    border:1px solid #0064e8 !important;
    background-color: #0064e8;
    color: #ffffff;
    font-size: 12px !important;
    line-height: 5px !important;
  }
  .onloadBtn{
    width:80px;
    height: 25px;
    border-radius: 50px !important;
    border:1px solid #0064e8 !important;
    background-color: #ffffff;
    color: #0064e8;
    font-size: 12px!important;
    line-height: 5px !important;
  }
  .content-top{
    position: relative;
    width: 100%;
    min-width:950px;
    height:auto;
    background-color: #b3d7ff;
  }
  .content-top a{
    margin-left: 10px;
    margin-right: 10px;
    position:absolute;
    color: #007bff;
    font-size: 14px;
  }

  .top-body{
    width: 950px;
    height: 30px;
    margin: 0 auto;
    padding-top: 4px;
    color: #ffffff;
    font-size: 14px;
    text-align: right;
  }
  .top-body a{
    margin-left: 10px;
    margin-right: 10px;
    color: #ffffff;
  }
  .content-header{
    width: 100%;
    min-width:950px;
    overflow: hidden;
  }
  .content-nav{
    height: 60px;
    border-bottom: 2px solid #d7d7d7;
    text-align: center;
    background-color: #ffffff;
  }
  .nav-body{
    /*width: calc(100% - 300px);*/
    width: 850px;
    margin: 0 auto;
    padding-top: 8px;
  }
  .nav-ul{
    margin-top: 10px;
    margin-left: 0px;
    font-family: '微软雅黑';
    font-size: 16px;
    align-items: center;
    list-style-type:none;
  }
  .nav-ul li{
    margin-left: 20px;
    text-align: center;
    flex: 1 0 auto;
    height: 100%;
  }
  .nav-ul:first-child{
    text-align: center;
  }
  .nav-ul li a{
    padding: 10px 10px;
    color: #000000;
    text-decoration:none;
  }
  .nav-ul li a:hover{
    background-color: #ffffff;
  }
  .nav-ul li a:focus{
    background-color: #ffffff;
    color: #0051bd;
  }
  .helloUse{
    background-color: #5daeff;
    color: #ffffff;
    position: absolute;
    right: 0px;
    font-size: 14px;
    padding: 5px 20px 8px 20px;
    border-bottom-left-radius: 20px;
  }
  .helloUsename{
    font-weight: 600;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/header/header.vue